"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_VIEWER_INFO = exports.DEFAULT_USER_DISPLAY_INFO = exports.DEFAULT_SPOTLIGHT_STORY_METADATA = exports.DEFAULT_PUBLISHER_DISPLAY_INFO = exports.DEFAULT_PAGE_LINKS = exports.DEFAULT_ONE_LINK = exports.DEFAULT_NOT_FOUND_METADATA = exports.DEFAULT_NOT_AVAILABLE_METADATA = exports.DEFAULT_LOCALIZATION = exports.DEFAULT_LENS_RESOURCE = exports.DEFAULT_LENS_DISPLAY_INFO = void 0;
exports.lensDisplayInfoOrDefault = lensDisplayInfoOrDefault;
exports.localizationOrDefault = localizationOrDefault;
exports.pageLinksOrDefault = pageLinksOrDefault;
exports.pageMetadataOrDefault = pageMetadataOrDefault;
exports.publisherDisplayInfoOrDefault = publisherDisplayInfoOrDefault;
exports.spotlightStoryMetadataOrDefault = spotlightStoryMetadataOrDefault;
exports.toMetricsInfo = toMetricsInfo;
exports.userDisplayInfoOrDefault = userDisplayInfoOrDefault;
exports.viewerInfoOrDefault = viewerInfoOrDefault;

var _common = require("../../generated-src/snapchat/web/stories/common");

var _links = require("../links");

var DEFAULT_ONE_LINK = "https://click.snapchat.com/aVHG?pid=snapchat_download_page&af_dp=https://link.snapchat.com/unlock&af_web_dp=https://www.snapchat.com/download&purpose=web_stories";
exports.DEFAULT_ONE_LINK = DEFAULT_ONE_LINK;
var DEFAULT_VIEWER_INFO = {
  country: "ZZ",
  // unknown
  locale: "en",
  // DEFAULT value of GDPR country is true, so that we don't add GA for 404 pages
  isGdprCountry: true
};
exports.DEFAULT_VIEWER_INFO = DEFAULT_VIEWER_INFO;
var DEFAULT_SPOTLIGHT_STORY_METADATA = {
  hashtags: [],
  lensMetadata: undefined,
  userMetadata: undefined,
  videoMetadata: undefined,
  contextCards: [],
  engagementStats: undefined,
  deeplink: "",
  description: "",
  oneLinkParams: undefined
};
exports.DEFAULT_SPOTLIGHT_STORY_METADATA = DEFAULT_SPOTLIGHT_STORY_METADATA;
var DEFAULT_LOCALIZATION = {
  direction: _common.LanguageDirection.AUTO
};
exports.DEFAULT_LOCALIZATION = DEFAULT_LOCALIZATION;
var DEFAULT_PUBLISHER_DISPLAY_INFO = {
  displayName: "",
  profileLogoDisplay: "BOTTOM",
  horizontalLogoUrl: "",
  // TODO: should we use a placeholder asset?
  squareHeroImageUrl: "",
  // TODO: should we use a placeholder asset?
  description: "",
  subscriberCount: "0"
};
exports.DEFAULT_PUBLISHER_DISPLAY_INFO = DEFAULT_PUBLISHER_DISPLAY_INFO;
var DEFAULT_LENS_RESOURCE = {
  checkSum: "",
  archiveLink: "",
  signature: "",
  lastUpdated: ""
};
exports.DEFAULT_LENS_RESOURCE = DEFAULT_LENS_RESOURCE;
var DEFAULT_LENS_DISPLAY_INFO = {
  scannableUuid: "",
  lensName: "",
  lensCreatorDisplayName: "",
  lensPreviewImageUrl: "",
  lensPreviewVideoUrl: "",
  iconUrl: "",
  unlockUrl: "",
  lensResource: DEFAULT_LENS_RESOURCE,
  userProfileUrl: "",
  lensCreatorUsername: "",
  lensId: "",
  lensCreatorSearchTags: [],
  isOfficialSnapLens: false
};
exports.DEFAULT_LENS_DISPLAY_INFO = DEFAULT_LENS_DISPLAY_INFO;
var DEFAULT_PAGE_LINKS = {
  oneLinkUrl: DEFAULT_ONE_LINK,
  snapchatCanonicalUrl: "https://link.snapchat.com/unlock",
  canonicalUrl: "https://story.snapchat.com",
  snapcodeImageUrl: "",
  downloadUrl: _links.downloadLink,
  oneLinkParams: undefined,
  snapchatDeepLinkUrl: "https://link.snapchat.com/unlock"
};
exports.DEFAULT_PAGE_LINKS = DEFAULT_PAGE_LINKS;
var DEFAULT_NOT_FOUND_METADATA = {
  pageType: _common.PageType.NOT_FOUND,
  pageTitle: "Snapchat",
  pageDescription: undefined,
  shareId: ""
};
exports.DEFAULT_NOT_FOUND_METADATA = DEFAULT_NOT_FOUND_METADATA;
var DEFAULT_NOT_AVAILABLE_METADATA = {
  pageType: _common.PageType.NOT_AVAILABLE,
  pageTitle: "Snapchat",
  pageDescription: undefined,
  shareId: ""
};
exports.DEFAULT_NOT_AVAILABLE_METADATA = DEFAULT_NOT_AVAILABLE_METADATA;
var DEFAULT_USER_DISPLAY_INFO = {
  displayName: "",
  emoji: "",
  hasBadge: false,
  profilePictureUrl: "",
  username: ""
};
exports.DEFAULT_USER_DISPLAY_INFO = DEFAULT_USER_DISPLAY_INFO;

function viewerInfoOrDefault(viewerInfo) {
  if (viewerInfo) return viewerInfo;else return DEFAULT_VIEWER_INFO;
}

function spotlightStoryMetadataOrDefault(storyMetadata) {
  if (storyMetadata) return storyMetadata;else return DEFAULT_SPOTLIGHT_STORY_METADATA;
}

function localizationOrDefault(localization) {
  if (localization) return localization;else return DEFAULT_LOCALIZATION;
}

function toMetricsInfo(props) {
  var viewerInfo = viewerInfoOrDefault(props.viewerInfo);
  return {
    country: viewerInfo.country
  };
}

function publisherDisplayInfoOrDefault(publisherDisplayInfo) {
  if (publisherDisplayInfo) return publisherDisplayInfo;else return DEFAULT_PUBLISHER_DISPLAY_INFO;
}

function userDisplayInfoOrDefault(userDisplayInfo) {
  if (userDisplayInfo) return userDisplayInfo;else return DEFAULT_USER_DISPLAY_INFO;
}

function lensDisplayInfoOrDefault(lensDisplayInfo) {
  if (lensDisplayInfo) return lensDisplayInfo;else return DEFAULT_LENS_DISPLAY_INFO;
}

function pageLinksOrDefault(pageLinks) {
  if (pageLinks) return pageLinks;else return DEFAULT_PAGE_LINKS;
}

function pageMetadataOrDefault(pageMetadata) {
  if (pageMetadata) return pageMetadata;else return DEFAULT_NOT_FOUND_METADATA;
}